import { create } from 'zustand';

import { normalizeError } from '../../api/core/errors';
import type { ApiErrorKind } from '../../api/core/errors';
import { UnitRepository } from '../../api/repository/unit';
import type { IztUnit } from '../../api/types';
import { userError } from '../userError';
import { type MaybeMsg } from '../../i18n/msg.ts';
import { getRenderable } from './renderable';
import type { UnitRenderable } from './renderable';

export type { UnitRenderable } from './renderable';

export interface IzteachUnitState {
  unit: IztUnit | null;
  renderable: UnitRenderable | null;
  loading: boolean;
  error: MaybeMsg | null;
  errorKind: ApiErrorKind | null;
  openUnit: (unitId: string) => Promise<IztUnit | null>;
  clear: () => void;
}

export const useIzteachUnitStore = create<IzteachUnitState>((set) => ({
  unit: null,
  renderable: null,
  loading: false,
  error: null,
  errorKind: null,
  async openUnit(unitId) {
    set({ loading: true, error: null, errorKind: null });
    try {
      const unit = await UnitRepository.fetchOne(unitId);
      set({ unit, renderable: getRenderable(unit), loading: false });
      return unit;
    } catch (error) {
      const normalized = normalizeError(error);
      set({ loading: false, error: userError(error), errorKind: normalized.kind });
      return null;
    }
  },
  clear: () => set({ unit: null, renderable: null, error: null, errorKind: null }),
}));
